<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">
        {{ item?.emailUserId ? $t('emailAccountUserEditModalTitle') : $t('emailAccountUserCreateModalTitle') }}
      </div>
    </template>
    <Spinner v-if="dataIsSending"/>
    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-5">
        <div class="p-float-label">
          <CustomDropdown id="email_account_user_signature"
                          :disabled="userSelectorDisabled"
                          :class="{'p-invalid' : submitted && !selectedUser}"
                          v-model="selectedUser"
                          @change="changeUser"
                          :options="usersData"
                          :clearSearchData="!visible"
                          :filter="true"
                          :filterFields="['full_name']"
                          :showClear="false">
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.full_name }}</span>
              </div>
              <span v-else style="visibility: hidden">.</span>
            </template>
            <template #option="slotProps">
              <div>
                <span>{{ slotProps.option.full_name }}<span v-if="roleLabel(slotProps.option.role)"> - {{ roleLabel(slotProps.option.role) }}</span></span>
              </div>
            </template>
          </CustomDropdown>
          <label for="email_account_user_signature">{{ $t('User') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !selectedUser">{{ $t('Required field') }}</small>
      </div>

      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-4">
        <LimitedCharsTextarea :submitted="submitted"
                              :rows="6"
                              v-model="emailUserData.signature"
                              :maxChars="signatureMaxChars"
                              :autocomplete="'new-password'"
                              :id="'email-account-user-signature'"
                              :label="$t('emailSignatureLabel')"/>
      </div>

      <div v-if="selectedUser && selectedUser.role > constants.userRoles.admin"
           class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3 p-d-flex p-ai-center">
        <div class="p-d-flex p-ai-center">
          <div class="p-d-flex p-ai-center">
            <InputSwitch id="email-account-user-can-view-inbox" v-model="canViewInbox"/>
          </div>
          <label for="email-account-user-can-view-inbox" class="switch-label pointer">
            {{ $t('canViewEmailsLabel') }}
          </label>
        </div>
      </div>

<!--      <template v-if="$store.getters.isOwnerOrHigher && selectedUser?.role === constants.userRoles.admin">-->
<!--        <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-4 p-d-flex p-ai-center">-->
<!--          <div class="p-d-flex p-ai-center">-->
<!--            <div class="p-d-flex p-ai-center">-->
<!--              <InputSwitch id="email-account-user-can-manage_access" v-model="canManageAccess"/>-->
<!--            </div>-->
<!--            <label for="email-account-user-can-manage_access" class="switch-label pointer">-->
<!--              {{ $t('canManageEmailAccessLabel') }}-->
<!--            </label>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->

    </div>

    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')" :disabled="disableSaveButton" icon="pi pi-check" class="p-button-text" @click="saveItem"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import constants from "@/constants";
import formatMixins from "@/mixins/formatMixins";

export default {
  mixins: [ showErrorsMixins, formatMixins ],
  emits: ['close', 'update-items', 'update-item'],
  name: 'EmailAccountUserModal',
  props: {
    emailAccountId: Number,
    item: Object,
    employees: {
      type: [Array, null],
      default: null,
    },
    visible: Boolean,
  },
  data() {
    return {
      userSelectorDisabled: false,
      usersData: [],
      signatureMaxChars: 500,
      dataIsSending: false,
      disableSaveButton: false,
      canViewInbox: true,
      // canManageAccess: false,
      emailUserData: {},
      submitted: false,
      selectedUser: null,
      constants,
    }
  },
  watch: {
    item(value) {
      if (!value) return false
      this.emailUserData = { ...value }
      this.canViewInbox = value.emailUserId ? !!value.can_view_inbox : true
      // this.canManageAccess = !!value.can_manage_access

      // if (value.user_id) {
      //   this.selectedUser = {
      //     id: value.user_id,
      //     full_name: value.full_name,
      //     role: value.role,
      //   }
      //   this.userSelectorDisabled = true
      // } else {
      //   this.userSelectorDisabled = false
      // }
      if (value.user_id) {
        this.selectedUser = {
          id: value.user_id,
          full_name: value.full_name,
          role: value.role,
        }

        if (value.role <= constants.userRoles.admin) {
          this.canViewInbox = true
        }

        this.userSelectorDisabled = true
      } else {
        this.userSelectorDisabled = false
      }
    },
    employees(value) {
      this.usersData = [...value]
    },
    visible() {
      if (!this.visible) {
        this.disableSaveButton = false
        this.dataIsSending = false
        this.submitted = false
        this.selectedUser = null
        this.userSelectorDisabled = false
      }
    },
  },
  methods: {
    // changeUser() {
    //   if (!this.selectedUser) return
    //
    //   if (this.selectedUser.role === constants.userRoles.owner) this.canViewInbox = true
    // },
    changeUser() {
      if (!this.selectedUser) return

      if (this.selectedUser.role <= constants.userRoles.admin) {
        this.canViewInbox = true
      }
    },
    async saveItem() {
      this.submitted = true
      if (!this.selectedUser || this.emailUserData.signature?.length > this.signatureMaxChars) {
        return false
      }
      this.disableSaveButton = true
      this.dataIsSending = true


      // let canManageSettings = null
      // let canManageCredentials = null
      // let canManageAccess = null

      // if (this.selectedUser.role === constants.userRoles.owner) {
      //   canManageSettings = 1
      //   canManageCredentials = 1
      //   canManageAccess = 1
      // } else if (this.selectedUser.role === constants.userRoles.admin) {
      //   canManageSettings = this.canManageAccess ? 1 : 0
      //   canManageCredentials = this.canManageAccess ? 1 : 0
      //   canManageAccess = this.canManageAccess ? 1 : 0
      // }

      // const emailUser = {
      //   emailUserId: this.emailUserData.emailUserId,
      //   user_id: this.selectedUser?.id,
      //   email_account_id: this.emailAccountId,
      //   can_view_inbox: this.selectedUser.role === constants.userRoles.owner ? 1 : this.canViewInbox ? 1 : 0,
      //   can_manage_settings: canManageSettings,
      //   can_manage_credentials: canManageCredentials,
      //   can_manage_access: canManageAccess,
      //   signature: this.emailUserData.signature
      // }
      const hasImplicitAccess =
          this.selectedUser.role <= constants.userRoles.admin

      const emailUser = {
        emailUserId: this.emailUserData.emailUserId,
        user_id: this.selectedUser.id,
        email_account_id: this.emailAccountId,
        can_view_inbox: hasImplicitAccess
            ? 1
            : this.canViewInbox ? 1 : 0,
        signature: this.emailUserData.signature
      }

      if (this.emailUserData.emailUserId) {
        try {
          const { status, data } = await httpClient.post(`email-account/update-user`, emailUser)
          if (status === 200 && data?.success) {
            await this.$store.dispatch('reloadLocationBootstrapData')

            emailUser.full_name = this.selectedUser.full_name
            emailUser.role = this.selectedUser.role

            this.$emit('update-items', emailUser.email_account_id)
            this.$emit('update-item', emailUser)
            this.$toast.add({severity: 'success', detail: this.$t('Data updated'), life: settings.toastLife});
            this.close()
          } else if(data?.error) {
            if (settings.isDevMode) console.log(data.error)
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      } else {
        try {
          const { status, data } = await httpClient.post(`email-account/create-user`, emailUser)
          if (status === 201 && data?.success) {
            await this.$store.dispatch('reloadLocationBootstrapData')

            emailUser.emailUserId = data.id
            emailUser.full_name = this.selectedUser.full_name
            emailUser.role = this.selectedUser.role
            emailUser.isNew = true

            this.$emit('update-items', emailUser.email_account_id)
            this.$emit('update-item', emailUser)
            this.$toast.add({severity:'success', detail: this.$t('Data saved'), life: settings.toastLife});
            this.close()
          } else if(data?.error) {
            if (settings.isDevMode) console.log(data.error)
          } else {
            this.showUnknownError()
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      }

    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'relative', top: '-10vh', width: '90%', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'relative', top: '-10vh', width: '450px', marginTop: '25px'}
      } else {
        return {position: 'relative', top: '-10vh', width: '450px', marginTop: '50px'}
      }
    }
  },

}
</script>